const d = 'm298-52 40-280H123l399-577h113l-40 320h260L409-52H298Z';

export default d;
